<template lang="pug">
pr-wrapper#worker(
  fs,
  zi="0",
  @nv-delete.native="($event) => $channelSelectWithNumber($event, false)",
  @nv-numpad.native="($event) => $channelSelectWithNumber($event, false)"
)
</template>

<script>
import services from "@/services/service"
import { mapGetters } from "vuex"

export default {
  name: "worker",
  data() {
    return {
      bootstrap: false
    }
  },
  computed: {
    isDeviceDS() {
      return __.device.get("using_by") === "DS"
    },
    ...mapGetters(["language"])
  },
  watch: {
    router(nval) {
      _$.vue.$emit("router", nval)
    },
    bootstrap(nval) {
      if (nval) this.prepare()
    },
    language(nval, oval) {
      this.$i18n.locale = nval.code
      this.$moment.locale(nval.code)

      if ((oval && oval.code === nval.code) || this.$store.state.splash) return

      if (__.guest.get() && __.guest.get("language") === nval.code) return true
      __.guest.update().then(() => __.platform.syncData("language"))
    }
  },
  mounted() {
    _$.vue.$once("ready", () => (this.bootstrap = true))
  },
  methods: {
    async prepare() {
      services.worker.init()
      services.action.init()

      this.boot()
    },
    async boot() {
      this.$store.commit("router", true)
      this.$store.commit("splash", false)

      if (__.device.get("using_by") === "DS") return __.platform.go(sessionStorage.getItem("homePage"))

      await __.platform.hasOpeningMedia("alarm")
      await __.platform.hasOpeningMedia("after_reboot")

      __.platform.go(sessionStorage.getItem("homePage"))
    }
  }
}
</script>

<style lang="scss" scoped>
#worker {
  display: flex;
}
</style>
